import { isRef, isReactive, isProxy, toRaw } from "vue";
function debounce(fn, wait) {
  let timer = null;
  return function(...args) {
    if (timer) {
      clearTimeout(timer);
    }
    const context = this;
    timer = setTimeout(() => {
      fn.apply(context, args);
    }, wait);
  };
}
async function fileToBase64(file) {
  return new Promise((resolve, reject) => {
    if (!file) resolve(void 0);
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      const result = reader.result;
      if (result) resolve(result);
      else resolve(void 0);
    };
  });
}
async function encodeFiles(files) {
  if (!(files == null ? void 0 : files.length)) return [];
  const encoded = [];
  for (const file of files) {
    const base64 = await fileToBase64(file);
    if (!base64) continue;
    encoded.push({ name: file.name, type: file.type, data: base64 });
  }
  return encoded;
}
function base64ToFile(base64Data, fileName) {
  const byteString = atob(base64Data.split(",")[1]);
  const byteArrays = new Uint8Array(byteString.length);
  for (let i = 0; i < byteString.length; i++) {
    byteArrays[i] = byteString.charCodeAt(i);
  }
  const matches = base64Data.match(/^data:([a-zA-Z0-9]+\/[a-zA-Z0-9-.+]+).*,.*$/);
  if ((matches == null ? void 0 : matches.length) !== 2) return;
  const mimeType = matches[1];
  const blob = new Blob([byteArrays], { type: mimeType });
  const file = new File([blob], fileName, { type: mimeType });
  return file;
}
function nl2br(text) {
  if (!text) return "";
  return text.replace(/(?:\r\n|\r|\n)/g, "<br>");
}
function deepToRaw(sourceObj) {
  const objectIterator = (input) => {
    if (Array.isArray(input)) {
      return input.map((item) => objectIterator(item));
    }
    if (isRef(input) || isReactive(input) || isProxy(input)) {
      return objectIterator(toRaw(input));
    }
    if (input && typeof input === "object") {
      return Object.keys(input).reduce((acc, key) => {
        acc[key] = objectIterator(input[key]);
        return acc;
      }, {});
    }
    return input;
  };
  return objectIterator(sourceObj);
}
function useUtilities() {
  return {
    debounce,
    fileToBase64,
    base64ToFile,
    nl2br,
    deepToRaw,
    encodeFiles
  };
}
export {
  base64ToFile,
  debounce,
  deepToRaw,
  encodeFiles,
  fileToBase64,
  nl2br,
  useUtilities
};
//# sourceMappingURL=index52.js.map
